/**
 * Only the latest load may update the screen (38.15). Switching days, weeks,
 * sections or venues quickly can make an older request answer last; without
 * this its data would replace the newer one.
 *
 *   const isCurrent = tracker.begin()        // day / week / venue switch
 *   try {
 *     const data = await fetch…
 *     if (!isCurrent()) return
 *     …
 *   } finally {
 *     isCurrent.done()
 *     if (isCurrent()) setLoading(false)
 *   }
 *
 * `beginQuiet()` is for in-place refreshes (after a save, on focus, polls):
 * it never cancels a switch that's loading — it's skipped while one is in
 * flight, and dropped if one starts before it answers.
 */
export function createFoodSafetyLatestRequest() {
  let mainSeq = 0
  let quietSeq = 0
  let mainInFlight = false

  const stale = () => false
  stale.done = () => {}
  stale.skipped = true

  return {
    begin() {
      mainSeq += 1
      quietSeq += 1
      mainInFlight = true
      const id = mainSeq
      const isCurrent = () => id === mainSeq
      isCurrent.done = () => {
        if (id === mainSeq) mainInFlight = false
      }
      return isCurrent
    },
    beginQuiet() {
      if (mainInFlight) return stale
      quietSeq += 1
      const q = quietSeq
      const m = mainSeq
      const isCurrent = () => q === quietSeq && m === mainSeq
      isCurrent.done = () => {}
      return isCurrent
    },
    /** Drop whatever is in flight (unmount). */
    cancel() {
      mainSeq += 1
      quietSeq += 1
      mainInFlight = false
    },
  }
}
